import { InformationCircleIcon } from "@heroicons/react/24/outline";

import { formatCurrency } from "../../../../../../../util";

const describeAboveSalePrice = ({
  amountAboveSalePrice,
  currencyCode,
  salePrice,
}) => {
  const excess = formatCurrency(amountAboveSalePrice, currencyCode);
  return salePrice == null
    ? `The To Be Invoiced amount is ${excess} above the offer amount, so no discount has been applied.`
    : `This work is selling ${excess} above its Sale Price of ${formatCurrency(salePrice, currencyCode)}, so no discount has been applied.`;
};

const AboveSalePriceNote = ({
  amountAboveSalePrice,
  currencyCode,
  salePrice,
}) =>
  amountAboveSalePrice > 0 ? (
    <div
      className="flex items-start gap-3 rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900"
      role="status"
    >
      <InformationCircleIcon
        className="mt-0.5 h-5 w-5 shrink-0"
        aria-hidden="true"
      />
      <div>
        <div className="font-semibold">Above Sale Price</div>
        <div>
          {describeAboveSalePrice({
            amountAboveSalePrice,
            currencyCode,
            salePrice,
          })}
        </div>
      </div>
    </div>
  ) : null;

export default AboveSalePriceNote;
